import { Link } from "react-router-dom";

export function FAQ() {
  return (
    <section className="w-full max-w-md mx-auto px-2 mt-0 pb-1 md:landscape:pb-0.5 lg:landscape:pb-0.5" data-debug-ignore-a11y>
      <p className="text-[10px] text-muted-foreground text-center leading-tight">
        Daily word: <span className="text-tile-correct font-medium">Green</span> = right, <span className="text-tile-present font-medium">Yellow</span> = wrong spot, <span className="text-muted-foreground font-medium">Gray</span> = absent.{' '}
        <Link to="/help" className="text-muted-foreground hover:text-foreground hover:underline font-medium" aria-label="More help and game instructions">More</Link>
      </p>
    </section>
  );
}
